import { createAsyncThunk } from "@reduxjs/toolkit";
import { itemsApi } from "@template/api";
import type { CreateItemRequest, UpdateItemRequest } from "@template/types";
import type { RootState } from "../store";
import {
  itemAdded,
  itemRemoved,
  itemUpdated,
  itemsLoaded,
  itemsRequestFailed,
  itemsRequestStarted,
} from "./items.slice";

function errorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  return "Something went wrong";
}

export const fetchItems = createAsyncThunk<void, void, { state: RootState }>(
  "items/fetchItems",
  async (_, { dispatch }) => {
    dispatch(itemsRequestStarted());
    try {
      const items = await itemsApi.list();
      dispatch(itemsLoaded(items));
    } catch (err) {
      dispatch(itemsRequestFailed(errorMessage(err)));
      throw err;
    }
  },
);

export const createItem = createAsyncThunk<void, CreateItemRequest, { state: RootState }>(
  "items/createItem",
  async (payload, { dispatch }) => {
    const item = await itemsApi.create(payload);
    dispatch(itemAdded(item));
  },
);

export const updateItem = createAsyncThunk<
  void,
  { id: string; payload: UpdateItemRequest },
  { state: RootState }
>("items/updateItem", async ({ id, payload }, { dispatch }) => {
  const item = await itemsApi.update(id, payload);
  dispatch(itemUpdated(item));
});

export const deleteItem = createAsyncThunk<void, string, { state: RootState }>(
  "items/deleteItem",
  async (id, { dispatch }) => {
    await itemsApi.remove(id);
    dispatch(itemRemoved(id));
  },
);
